<template>
  <div>
    <IconButton
      aria-label="Gå tillbaka"
      icon-classes="text-[2.4rem] self-baseline"
      icon-name="arrow-left"
      @click="familyStore.showFamilyDrawerPdpStart()"
      @keyup.enter.once.self.prevent="familyStore.showFamilyDrawerPdpStart()"
      @keyup.space.once.self.prevent="familyStore.showFamilyDrawerPdpStart()"
    />

    <AppNotification type="info" class="w-full mt-20">
      <template #header>
        <p v-if="familyStore.ui.showNewCustomerFlow" class="heading-xxs">
          Jag är ny kund
        </p>
        <p v-else class="heading-xxs">Jag är befintlig kund</p>
      </template>
      <p v-if="familyStore.ui.showNewCustomerFlow">
        Jag har inget Halebop abonnemang sedan tidigare.
      </p>
      <p v-else>
        Jag har redan ett 20 GB abonnemang eller högre som jag vill koppla ett
        familjeabonnemang till.
      </p>
      <button
        tabindex="0"
        aria-label="Ändra till familjeabonnemang för befintlig kund"
        class="body-link-md text-text-link underline halebop-focus mt-10 hover:text-text-link-hover active:bg-surface-action-hover"
        @click="familyStore.showFamilyDrawerPdpStart()"
        @keyup.enter.once.self.prevent="familyStore.showFamilyDrawerPdpStart()"
        @keyup.space.once.self.prevent="familyStore.showFamilyDrawerPdpStart()"
      >
        Ändra
      </button>
    </AppNotification>
  </div>
</template>

<script lang="ts" setup>
const familyStore = useFamilyStore();
</script>

<style scoped></style>
